import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';
import { InputFomat } from '../model/input.model';

@Component({
  tag: 'form-upload',
  styleUrl: 'form-upload.css',
  shadow: false,
})
export class FormUpload {
  @Prop() inputValue: InputFomat;
  @Prop() formData: { [key: string]: any };


  @Event() valueChanged: EventEmitter<{ id: string; value: any }>;

  private handleFileUpload = (event: any) => {
    const files = event?.detail as File[];
    if (files) {
      const fileArray = Array.from(files); 
      const value = fileArray.map(file => ({
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified
      }))
      this.formData = value
      this.valueChanged.emit({ id: this.inputValue.id, value });
    }
  };

  render() {
    return (
      <div class="form-box">
        <label htmlFor={this.inputValue.id}>{this.inputValue.label}</label>
        <ix-upload
          type="file"
          id={this.inputValue.id}
          multiple={this.inputValue.allow_multi_selection}
          accept={this.inputValue.allowed_fileextensions.join(',')}
          onFilesChanged={(event) => this.handleFileUpload(event)}
          selectFileText={this.inputValue.helperText}
        />
        <ul>
          {this.formData && this.formData.map((file, index) => (
            <li key={index}>
              {file.name} ({file.size} bytes)
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
